export default {
  // AdminUsersView
  manageUsers: 'Administrar Usuarios',
  users: 'Usuarios',
  roles: 'Roles',

  // AdminUsersTable
  addUser: 'Agregar Usuario',
  activeUsers: 'Mostrar usuarios activos',
  inactiveUsers: 'Mostrar usuarios desactivados',
  cannotModifyOwnStatus: 'No puedes modificar tu propio estado',
  activateUser: 'Activar usuario',
  deactivateUser: 'Desactivar usuario (el usuario no podrá ingresar a la plataforma)',
  deactivateUserConfirmTitle: '¿Desactivar usuario?',
  activateUserConfirmTitle: '¿Activar usuario?',
  deactivateUserConfirmText: 'El usuario no podrá ingresar a la plataforma mientras esté desactivado.',
  activateUserConfirmText: 'El usuario podrá volver a ingresar a la plataforma.',
  deactivateAction: 'Desactivar',
  activateAction: 'Activar',
  userDeactivatedSuccessfully: 'Usuario desactivado exitosamente.',
  userActivatedSuccessfully: 'Usuario activado exitosamente.',
  userInformation: 'Información del Usuario',
  sendEmailToUser: 'Enviar Correo para reestablecer contraseña',
  editUser: 'Editar Usuario',
  manageUserPermissions: 'Administrar Permisos para el Usuario.',
  copyPermissions: 'Copiar Permisos',
  deleteUser: 'Eliminar Usuario',
  cannotDeleteCurrentUser: 'No puedes eliminar el usuario con el que ingresaste',
  createUser: 'Crear Usuario',
  copyPermissionsFrom: 'Copiar Permisos de',
  selectUserToCopyPermissions: 'Seleccione el Usuario del cual desea copiar los Permisos.',
  cancel: 'Cancelar',
  copy: 'Copiar',
  permissionsCopiedSuccessfully: 'Permisos Copiados con Éxito',
  userCreatedSuccessfully: 'Usuario Creado',
  emailSentSuccessfully: 'Correo Enviado',
  deletingUser: 'Eliminando usuario...',
  userDeletedSuccessfully: 'Usuario Eliminado',
  filterByRole: 'Filtrar por rol',
  clearFilter: 'Limpiar',
  selectRoles: 'Seleccionar roles...',
  noRolesAvailable: 'Sin roles disponibles',
  superUser: 'Super Usuario',

  // GroupNameAssignment
  createRole: 'Crear Rol',
  modifyRoleName: 'Modificar Nombre del Rol',
  deleteRole: 'Eliminar Rol',
  createNewRoleName: 'Crear Nuevo Nombre del Rol',
  group: 'Grupo',
  deleteRoleConfirmation: '¿Está seguro de que desea eliminar el Rol?',
  roleDeletedSuccessfully: 'Rol eliminado.',

  // RoleForm
  modifyRole: 'Moficar Rol',
  name: 'Nombre',
  selectPermissionType: 'Debe seleccionar un tipo de permiso.',
  roleCreatedSuccessfully: 'Rol creado.',
  roleUpdatedSuccessfully: 'Rol actualizado.',

  // UserForm
  firstName: 'Nombre',
  firstNames: 'Nombres',
  lastName: 'Apellido',
  lastNames: 'Apellidos',
  email: 'Correo',
  emailNotAvailable: 'Este correo no está disponible para su uso.',
  password: 'Contraseña',
  passwordRequirements: 'La contraseña de estar compuesta al menos por:',
  passwordLowercase: 'Al menos una letra en minúsculas.',
  passwordUppercase: 'Al menos una letra en mayúsculas.',
  passwordNumber: 'Al menos un número.',
  passwordSymbol: 'Al menos un simbolo.',
  passwordMinLength: 'Debe tener 8 carácteres como mínimo.',
  identifierType: 'Tipo de Identificador',
  identifier: 'Identificador',
  role: 'Rol',
  selectRole: 'Debe seleccionar un rol.',
  mustSelect: 'Debe seleccionar un',
  cohort: 'Cohorte',
  cohortValidation: 'Este campo es obligatorio y debe colocar un año válido',
  bibliographyNotifications: 'Notificaciones de la biblioteca',
  bibliographyNotificationsTooltip: 'Si está seleccionado, recibirás notificaciones sobre cambios en el catálogo o nuevas adquisiciones.',
  userStatus: 'Estado del Usuario',
  active: 'Activo',
  inactive: 'Inactivo',
  userUpdatedSuccessfully: 'Usuario Actualizado',
  fieldRequired: 'Este campo es obligatorio.',
  invalidEmail: 'El correo no tiene un formato válido.',
  minLengthError: 'Este campo debe tener al menos {min} caracteres.',

  // AdminInstitutionView
  configuration: 'Configuración',
  logs: 'Logs',
  bulkLoading: 'Carga masiva',

  // InstitutionBulkLoading
  bulkDataLoading: 'Carga masiva de datos',
  howItWorks: '¿Cómo funciona?',
  bulkLoadingDescription: 'Las plantillas se descargan con la información actual de la plataforma. Una vez completes los datos, contáctanos para procesar la carga.',
  downloadStepDescription: 'Descarga la plantilla con los datos actuales',
  completeStepDescription: 'Rellena la información en el archivo Excel',
  contactStepDescription: 'Envíanos el archivo para procesarlo',
  availableTemplates: 'Plantillas disponibles',
  bulkLoadingTemplateFor: 'Plantilla para carga masiva de {entity}',
  downloadTemplateXLSX: 'Descargar plantilla XLSX',
  generatingTemplate: 'Generando plantilla...',
  templateDownloadedSuccessfully: 'Plantilla descargada correctamente',

  // InstitutionLogsView
  institutionLogs: 'Logs de la Institución',
  institutionLogsSubtitle: 'Historial de cambios realizados en la institución (registros de 1 a 2 meses)',
  update: 'Actualizar',
  searchPlaceholder: 'Buscar por usuario, email o modelo...',
  date: 'Fecha',
  clearDate: 'Limpiar Fecha',
  actionType: 'Tipo de acción',
  allActions: 'Todas las acciones',
  creation: 'Creación',
  updateAction: 'Actualización',
  deletion: 'Eliminación',
  user: 'Usuario',
  model: 'Modelo',
  dateAndTime: 'Fecha y Hora',
  action: 'Acción',
  ip: 'IP',
  viewDetails: 'Ver detalles',
  logDetails: 'Detalles del Log',
  createdObject: 'Objeto Creado',
  deletedObject: 'Objeto Eliminado',
  previous: 'Anterior:',
  new: 'Nuevo:',

  // PermissionTable
  allowCreate: 'Permitir crear {entity}',
  selectAllIncludingFuture: 'Seleccionar todos (incluyendo los que se creen posteriormente)',
  selectedCount: 'Cantidad de seleccionados',
  savePermissions: 'Guardar Permisos',
  permissionsModifiedTitle: 'Permisos Guardados',
  permissionsModifiedText: 'Los permisos de edición han sido guardados. Haz clic en Continuar para configurar qué {entity1} y {entity2} pueden abrirse o cerrarse.',
  permissionUpdated: 'Permiso actualizado',

  // AccessForm
  partialLocks: 'Candados Parciales',
  accessFacultyDirectorWarning: 'Si se le otorga el permiso de Editar o Eliminar, este rol solo podrá modificar los objetos dentro de las {entity1} de las {entity2} seleccionadas.',
  accessInstructionalAdminWarning: 'Si se selecciona el permiso de Editar o Eliminar, este rol solo podrá modificar el {entity}',
  accessCareerDirectorOrEgressWarning: 'Si se le otorga el permiso de Editar o Eliminar, este rol solo podrá modificar los objetos dentro de las {entity} seleccionadas.',
  accessRequiresRole: 'Para crear un Accesos es necesario que el Usuario cuenta con un Rol',
}
